export default "__VITE_ASSET__D5bH9RU8__"